import "../messageStyles.css";
import OptionMenu from "../OptionMenu";
import { Lock, MailQuestion, Satellite } from "lucide-react";
import IconWithTooltip from "../IconWithTooltip";
import { MESSAGE_ENCRYPTED_TOOLTIP, MESSAGE_SATELLITE_TOOLTIP, MESSAGE_UNVERIFIED_SENDER_TOOLTIP } from "@/constants/ui";
import LocationLink from "../LocationLink";

interface ReceivedTextMessageProps {
  id: number;
  created: string;
  time: string;
  msg: string;
  isEncrypted?: boolean;
  isKeyExchange?: boolean;
  senderUsername?: string;
  isUnverified?: boolean;
  isSatellite?: boolean;
  lat?: string;
  lng?: string;
}

const ReceivedTextMessage = ({
  id,
  created,
  time,
  msg,
  isEncrypted,
  isKeyExchange,
  senderUsername,
  isUnverified,
  isSatellite,
  lat,
  lng,
}: ReceivedTextMessageProps) => {

  if (isKeyExchange) {
    return (
      <div key={id} className="message-container group">
        <div className="items-start message-time-container">
          <span className="message-time">{created ? time : "now"}</span>
          <div className="options-menu">
            <div className="message-text-container received-color opacity-70 italic">
              <p className="message-text">{msg}</p>
            </div>
            <OptionMenu/>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div key={id} className="message-container group">
      <div className="items-start message-time-container">
        <div className="flex items-center gap-2">
          {senderUsername && (
            <span className="text-xs font-semibold text-neutral-500">{senderUsername}</span>
          )}
          <span className="message-time">{created ? time : "now"}</span>
        </div>
        <div className="options-menu">
          <div className="message-text-container received-color">
            <p className="message-text">
              {msg}
            </p>
          </div>
          {isEncrypted && (
            <IconWithTooltip label={MESSAGE_ENCRYPTED_TOOLTIP}>
              <Lock size={12} className="text-green-500" />
            </IconWithTooltip>
          )}
          {isUnverified && (
            <IconWithTooltip label={MESSAGE_UNVERIFIED_SENDER_TOOLTIP}>
              <MailQuestion size={12} className="text-amber-500" />
            </IconWithTooltip>
          )}
          {isSatellite && (
            <IconWithTooltip label={MESSAGE_SATELLITE_TOOLTIP}>
              <Satellite size={15} className="text-blue-400" />
            </IconWithTooltip>
          )}
          <OptionMenu/>
        </div>
        <LocationLink lat={lat} lng={lng} />
      </div>
    </div>
  );
};

export default ReceivedTextMessage;
